import axios from "axios";
import _ from "lodash";
import store from "../store";
import { sessionOut } from "../reducers/auth/session.reducer";
import { extractCompanySlug } from "./helper";

/**
 * Export a default instance for requesting an APIs
 *
 * This instance includes auth Header
 */
const httpRequest = () => {
  const storeData = store.getState();
  const token = _.get(storeData, "session.token", null);
  // URL can still be /login during the post-sign-in redirect, while Redux
  // already has the company. Prefer the path, then fall back to session.
  const companySlug =
    extractCompanySlug() ||
    _.get(storeData, "session.currentCompany.slug", "") ||
    "";

  const httpRequest = axios.create({
    baseURL: process.env.REACT_APP_API_END_POINT,
    timeout: 110000, // 1 minute
    headers: {
      Authorization: token,
      ...(companySlug ? { "x-company": companySlug } : {}),
      "x-device": "web",
    },
  });

  // Watch every response received from the server
  httpRequest.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === 401) {
        store.dispatch(sessionOut());
      }
      return Promise.reject(error);
    }
  );

  return httpRequest;
};

export default httpRequest;

/**
 * Export an Axios instance
 *
 * This instance does not include auth Header
 * This will be used to call open APIs which does not accept Auth Header
 */
export const openHttpRequest = () =>
  axios.create({
    baseURL: process.env.REACT_APP_API_END_POINT,
    timeout: 110000, // more then 1 minutes
  });
